import { Autocomplete as AutocompleteUi, TextField } from "@mui/material";
import Label from "../Label";
import i18next from "i18next";
import React from "react";

interface AutocompleteProps {
	options: any[];
	onChange: (value: any) => void;
	onInputChange?: (e: any) => void;
	datatestid: string | null;
	id?: string | undefined;
	placeholder?: string | undefined;
	label?: string | null;
	className?: string;
	error?: string | null;
	showValue?: boolean;
	renderValue?: (value: any) => JSX.Element;
	value?: any;
	loading?: boolean;
	required?: boolean;
}

const Autocomplete = ({
	className,
	label,
	options,
	onChange,
	onInputChange,
	datatestid,
	id,
	placeholder,
	error,
	showValue,
	renderValue = (value) => <div>{value?.name ?? value}</div>,
	value,
	loading = false,
	required,
}: AutocompleteProps) => {
	return (
		<div className={className}>
			{label && <Label text={label} required={required} />}

			{!showValue && (
				<>
					<AutocompleteUi
						disablePortal
						onInputChange={onInputChange}
						options={options}
						id={id}
						lang="es"
						getOptionLabel={(option) => {
							if (typeof option === "string") return option;
							return option?.label || option?.name || "";
						}}
						value={
							!!value
								? { ...value, name: value.name ?? value.label, label: value.label ?? value.name }
								: undefined
						}
						sx={{ height: 40 }}
						onChange={(_, value) => onChange(value)}
						renderInput={(params) => (
							<TextField
								{...params}
								error={!!error}
								inputProps={{
									...params.inputProps,
									"data-testid": datatestid,
									id,
								}}
								placeholder={placeholder}
							/>
						)}
						loading={loading}
						loadingText={i18next.t("searching")}
						noOptionsText={i18next.t("no-results")}
					/>
				</>
			)}
			{showValue && value && renderValue?.(value)}
			{showValue && !value && <div>{i18next.t("no-value")}</div>}
		</div>
	);
};

export default Autocomplete;
